import decode from 'jwt-decode'
import LocalStorageService from './localstorageService'

export const USER_LOGGED = '@BI:User'
export const TOKEN = '@BI:Token'
export const REFRESH_TOKEN = '@BI:RefreshToken'

export default class AuthService {
    state = {
        roles: [],
        isAutenticado: false,
        isLoading: true
    }

    static isAuthenticated(){
        const token = localStorage.getItem(TOKEN)
        if(token){
            const decodedToken = decode(token);
            const expiration = decodedToken.exp;
    
            const isTokenInvalido = Date.now() >= (expiration * 1000);
            if(!isTokenInvalido === true){
                return true;
            }
        }
        return false;
    }

    static logout(){
        LocalStorageService.removeItem(USER_LOGGED);
        LocalStorageService.removeItem(TOKEN);
        LocalStorageService.removeItem(REFRESH_TOKEN);
        LocalStorageService.removeItem("email");
        LocalStorageService.removeItem("branch");
    };

    static getRefreshToken(){
        return localStorage.getItem(REFRESH_TOKEN);
    }

    static login(usuario, token){
        LocalStorageService.addItem(USER_LOGGED, usuario);
        LocalStorageService.addItem(TOKEN, token);
    }

    static getUser(){
        const user = localStorage.getItem(TOKEN)
        if(user){
            const decoded = decode(user);
            return decoded ;
        }else{
            return null;
        } 
    }
}